import type { ReactElement } from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { PolicyViewer } from 'module/policy/components/PolicyViewer';

import { useDeviceHandoffActions } from '../hooks/useDeviceHandoffActions';
import { DeviceHandoffActions } from '../state/actions';

const COORDINATOR_RETURN_PATH = '/';

export const PolicyRoute = (): ReactElement => {
    const { t } = useTranslation('policy');
    const dispatch = useDispatch();
    const { endRespondentTurn } = useDeviceHandoffActions();
    const [isReturningToClinician, setIsReturningToClinician] = useState(false);

    const returnDeviceToClinician = useCallback((): void => {
        setIsReturningToClinician(true);
        endRespondentTurn(COORDINATOR_RETURN_PATH);
    }, [endRespondentTurn]);

    return (
        <PolicyViewer
            onAccepted={(): void => {
                dispatch(DeviceHandoffActions.policyAccepted());
            }}
            secondaryAction={{ label: t('policy.back'), onClick: returnDeviceToClinician }}
            forceLoading={isReturningToClinician}
        />
    );
};
